import { Route, Routes as BaseRoutes } from "react-router";

import { DashboardLayout } from "./layouts/dashboard";
import { Account } from "./routes/account";
import { AuthCallback } from "./routes/auth-callback";
import { CreateSKU } from "./routes/create-sku";
import { GasCalculator } from "./routes/gas-calculator";
import { Images } from "./routes/images";
import { NoOrganization } from "./routes/no-org";
import { Organization } from "./routes/organization";
import { Organizations } from "./routes/organizations";
import { Owners } from "./routes/owners";
import { Sku } from "./routes/sku";
import { Skus } from "./routes/skus";
import { Splash } from "./routes/splash";
import { Tag } from "./routes/tag";
import { Tags } from "./routes/tags";
import { Tracks } from "./routes/tracks";
import { Verifications } from "./routes/verifications";
import { Videos } from "./routes/videos";
import { WebExperience } from "./routes/web-experience";

const Routes = () => (
  <BaseRoutes>
    <Route path="/" element={<Splash />} />
    <Route path="/auth/callback" element={<AuthCallback />} />
    <Route path="/no-organization" element={<NoOrganization />} />

    <Route path="skus/:skuId/web-experience" element={<WebExperience />} />

    <Route element={<DashboardLayout />}>
      <Route path="skus" element={<Skus />} />
      <Route path="skus/create" element={<CreateSKU />} />

      <Route path="skus/:skuId" element={<Sku />} />
      <Route path="skus/:skuId/product" element={<Sku />} />
      <Route path="skus/:skuId/overview" element={<Sku />} />
      <Route path="skus/:skuId/analytics" element={<Sku />} />
      <Route path="skus/:skuId/webpage" element={<Sku />} />
      <Route path="skus/:skuId/blockchain" element={<Sku />} />

      <Route path="images" element={<Images />} />
      <Route path="videos" element={<Videos />} />
      <Route path="tracks" element={<Tracks />} />

      <Route path="owners" element={<Owners />} />
      <Route path="tags" element={<Tags />} />
      <Route path="tags/:tagUid" element={<Tag />} />
      <Route path="verifications" element={<Verifications />} />
      <Route path="organization" element={<Organization />} />
      <Route path="organizations" element={<Organizations />} />
      <Route path="gas-calculator" element={<GasCalculator />} />
      <Route path="account" element={<Account />} />
    </Route>
  </BaseRoutes>
);

export default Routes;
